const TableListeners = ({
  _rows,
  _columns,
  trackKeybindings,
  selectedCell,
  isEditingCell,
  setSelectedCell,
  setIsEditingcell,
}) => {

  const filteredColumns = _columns.filter((column) => !column.internal);

  const onKeyUp = (e) => {

    if (!trackKeybindings || ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Escape", "Enter"].indexOf(e.key) === -1) 
      return;

    e.preventDefault();
    e.stopPropagation();

    if (e.key === "Enter") {
      setIsEditingcell(true);
      return;
    }

    if (e.key === "Escape") {
      const el = document.getElementById("table-current-cell");
      if(el) el.blur();
      setIsEditingcell(false);
      return;
    }

    if (isEditingCell)
      return;

    if (selectedCell && selectedCell.row != -1) {

      let row = selectedCell.row;
      let column = selectedCell.column;

      // if (!e.shiftKey) return;
      if (e.key === "ArrowUp") row--;
      if (e.key === "ArrowDown") row++;
      if (e.key === "ArrowLeft") column--;
      if (e.key === "ArrowRight") column++;

      if (row < 0) row = 0;
      if (row >= _rows.length) row = _rows.length - 1;
      if (column < 0) column = 0;
      if (column >= filteredColumns.length) column = filteredColumns.length - 1;

      const el = document.getElementById("table-current-cell");
      if(el) el.blur();

      setSelectedCell({ row, column });
      setIsEditingcell(false);

    }

    return false;

  }

  return {
    onKeyUp
  }

}

export default TableListeners;